module.exports = __webpack_public_path__ + "img/symbol_s04.f820577.svg";